$(document).ready(function() {

  $('.custom-product-variants-img').click(function() {
    var variantId = $(this).data('variant-id');
    var variantPrice = $(this).data('variant-price');
    var variantEarnMileage = $(this).data('variant-earn-mileage');
    var variantCompareAtPrice = $(this).data('variant-compare_at_price');
    var productContainer = $(this).closest('.custom-product');
    var newImageSrc = $(this).attr('src');
    var productHandle = productContainer.attr('id');
    console.log("variantCompareAtPrice");
    console.log(variantCompareAtPrice);
    console.log("variantCompareAtPrice");
    let DiscountRate;
    if (variantCompareAtPrice != null && variantCompareAtPrice > variantPrice) {
      DiscountRate = Math.round((1 - parseFloat(variantPrice.replace(/[\$,]/g, '')) / parseFloat(variantCompareAtPrice.replace(/[\$,]/g, ''))) * 100);
      DiscountRate = `${DiscountRate}% OFF`;
      console.log(productContainer);
      productContainer.find('.price-budge').addClass('on');
      productContainer.find('.price__sale__flex').addClass('price--compare-at');
      productContainer.find('.custom-product-compare-at-price').text(variantCompareAtPrice);
      productContainer.find('.custom-product-price').text(variantPrice);
      productContainer.find('#grid-item--earn-mileage').text(variantEarnMileage);
    } else {
      DiscountRate = "";
      productContainer.find('.price-budge').removeClass('on');
      productContainer.find('.price__sale__flex').removeClass('price--compare-at');
      productContainer.find('.custom-product-price').text(variantPrice);
      productContainer.find('.custom-product-compare-at-price').text("");
      productContainer.find('#grid-item--earn-mileage').text(variantEarnMileage);
    }

    productContainer.find('#featured-img').attr('src', newImageSrc);
    productContainer.find('.custom-product-link').each(function() {
      var baseUrl = $(this).attr('href').split('?')[0];
      $(this).attr('href', baseUrl + '?variant=' + variantId);
    });
    productContainer.find('.price-budge').text(DiscountRate);

    productContainer.find('.custom-product-variants-img').removeClass('selected');
    $(this).addClass('selected');

    productContainer.find('.custom-product-add').find('input[type="hidden"]').val(variantId);

    if (variantInventoryMap[productHandle][variantId] > 0) {
      productContainer.find('.custom-product-add').addClass('possible');
      productContainer.find('.custom-product-icon').prop('disabled', false);
  } else {
      productContainer.find('.custom-product-add').removeClass('possible');
      productContainer.find('.custom-product-icon').prop('disabled', true);
  }  
  });
  
	$('.custom-product-img').on({
    mouseenter: function() {
      var productContainer = $(this).closest('.custom-product');
      var productHandle = productContainer.attr('id');
      var selectedVariantTitle = productContainer.find('.custom-product-variants-img.selected').attr('alt');
      var firstImg = productContainer.find('.custom-product-img.first-media');
      var secondImg = productContainer.find('.custom-product-img.second-media');

      $(this).data('previous-src', $(this).attr('src'));

      if (productMediaMap[productHandle] && productMediaMap[productHandle][selectedVariantTitle]) {
          $(this).attr('src', productMediaMap[productHandle][selectedVariantTitle]);
      } else if(secondImg.length > 0) {
          secondImg.removeClass('d-none');
          firstImg.addClass('d-none');
      }
    },
    mouseleave: function() {
      var productContainer = $(this).closest('.custom-product');
      var firstImg = productContainer.find('.custom-product-img.first-media');
      var secondImg = productContainer.find('.custom-product-img.second-media');

      if(secondImg.length > 0){
          secondImg.addClass('d-none');
          firstImg.removeClass('d-none');
      }
      $(this).attr('src', $(this).data('previous-src'));
    }
  });
});